import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { useCart } from '../context/CartContext';
const PLACEHOLDER_IMG = 'https://cdn.magicpatterns.com/uploads/9tqLH7djkK9zjrdtQmqAeL/recetas-air-fryer-argentinas-portada_mockup3d_sinfondo.png';
const bonusBooks = [{
  title: 'Plan de Comidas Saludables 30 Días',
  subtitle: 'Tu Menú Completo con Freidora de Aire: Desayuno, Almuerzo, Merienda y Cena',
  image: 'https://cdn.magicpatterns.com/uploads/vRnuZaQKAVcW2wQetWPZYY/plan-de-comidas-saludables-30-dias-mockup3d.png'
}, {
  title: 'Guía de Limpieza y Mantenimiento',
  subtitle: 'Cómo Cuidar tu Freidora de Aire para que Dure Años y Funcione Siempre Perfecto',
  image: 'https://cdn.magicpatterns.com/uploads/ibQ34Rq7M1EtbbfucbA8Ej/guia-de-limpieza-y-mantenimiento-mockup3d.png'
}, {
  title: 'Lista de Compras Inteligente',
  subtitle: 'El Súper de la Semana para Cocinar Sano Sin Gastar de Más',
  image: 'https://cdn.magicpatterns.com/uploads/6XAXRWQfDAY7MZsdaKNZPS/lista-de-compras-inteligente-mockup3d.png'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BonusEbooksSection() {
  const {
    setCartOpen
  } = useCart();
  return <section className="w-full py-12 md:py-20 px-6 bg-surface" data-id="element-18">
      <div className="max-w-[900px] mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-20">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary font-bold text-sm uppercase tracking-wider px-4 py-2 rounded-full mb-6" data-id="element-21">
            <Gift className="w-4 h-4" data-id="element-22" />
            Bonus incluidos gratis
          </div>
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-23">
            Recibís 3 eBooks extra totalmente gratis
          </h2>
          <p className="text-charcoal/70 text-lg max-w-lg mx-auto leading-relaxed" data-id="element-24">
            Van incluidos automáticamente con tu compra. Los recibís dentro del
            mismo archivo de descarga, sin hacer nada extra.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-25">
          {bonusBooks.map((book, index) => <motion.div key={index} variants={itemVariants} className="bg-background rounded-2xl shadow-soft border border-primary/10 flex flex-col relative overflow-hidden" data-id="element-26">
              {/* Gratis badge */}
              <div className="absolute top-3 right-3 z-10 text-2xl" data-id="element-27">🎁</div>

              {/* Book image */}
              <div className="bg-surface/50 flex items-center justify-center pt-6 px-6" data-id="element-28">
                <img src={book.image} alt={book.title} className="h-40 object-contain" data-id="element-29" />
              </div>

              {/* Text content */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-30">
                <h3 className="font-bold text-charcoal text-base mb-2 leading-snug" data-id="element-31">
                  {book.title}
                </h3>
                <p className="text-sm text-charcoal/70 leading-relaxed mb-3" data-id="element-32">
                  {book.subtitle}
                </p>
                <div className="flex items-center gap-2 mt-auto" data-id="element-33">
                  <span className="text-sm text-charcoal/40 line-through" data-id="element-34">
                    $9.990
                  </span>
                  <span className="text-sm font-bold text-primary" data-id="element-35">
                    ¡GRATIS con tu compra!
                  </span>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-10 text-center" data-id="element-36">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => setCartOpen(true)} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-10 rounded-xl shadow-soft transition-colors text-lg" data-id="element-37">
            Descargar ahora →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}